import type { CancelScrapingRunRequest, CancelScrapingRunResponse } from '../types';

import { z } from 'zod';

import { internalApiClient } from '@/shared/api-client/internal-api-client';

const CancelScrapingRunRequestSchema = z
  .object({
    reason: z.string().optional(),
  })
  .optional() satisfies z.ZodType<CancelScrapingRunRequest | undefined>;

export async function cancelScrapingRun(
  runId: string,
  data?: CancelScrapingRunRequest,
): Promise<CancelScrapingRunResponse> {
  const payload = CancelScrapingRunRequestSchema.parse(data);
  const response = await internalApiClient.post<CancelScrapingRunResponse>(
    `scraping-runs/${runId}/cancel`,
    payload == null ? undefined : { json: payload },
  );

  return response.json();
}
